// src/components/HydrationErrorBoundary.js
import React from 'react';

class HydrationErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if this is a hydration error
    const isHydrationError = error.message && (
      error.message.includes('Hydration') ||
      error.message.includes('418') ||
      error.message.includes('423') ||
      error.message.includes('Text content does not match') ||
      error.message.includes('Expected server HTML')
    );

    if (isHydrationError) {
      console.warn('Hydration error detected, will recover by client-side rendering:', error.message);
      return { hasError: true, error };
    }

    // For non-hydration errors, don't catch them here
    throw error;
  }

  componentDidCatch(error, errorInfo) {
    console.warn('HydrationErrorBoundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // For hydration errors, just re-render the children
      // This allows React to recover by client-side rendering
      return this.props.children;
    }

    return this.props.children;
  }
}

export default HydrationErrorBoundary;
